/**
 * Facets reducer, gotta do some super fancy magic here
 * @param  {object} acc          routing state
 * @param  {object} payload      action payload
 * @param  {object} key          key for facets
 * @param  {object} routingState current routing state
 * @return {object}              new routing state
 */
export default function facets(acc, payload, key, routingState) {
  const newVal = payload;

  // handle config for individual indicator settings
  if (Object.keys(newVal).find((x) => 'distribution' === x)) {
    if (!routingState[key] ||
      (routingState[key] && !routingState[key].distribution)
    ) {
      return {
        ...acc,
        [key]: {
          ...routingState[key],
          distribution: [newVal.distribution],
        },
      };
    } else if (routingState[key] && routingState[key].distribution) {
      if (
        routingState[key].distribution.every((x) => x !== newVal.distribution)
      ) {
        return {
          ...acc,
          [key]: {
            ...routingState[key],
            distribution: [
              ...routingState[key].distribution || [],
              newVal.distribution,
            ],
          },
        };
      } // else
      return {
        ...acc,
        [key]: {
          ...routingState[key],
          distribution: routingState[key]
            .distribution
            .filter((x) => x !== newVal.distribution),
        },
      };
    }
  }
  // Everything else is a simple replace
  return {
    ...acc,
    [key]: {
      ...routingState[key],
      ...newVal,
    },
  };
}



// WEBPACK FOOTER //
// ./app/middleware/router/facets.js